import { BooleanInput, SearchInput } from 'react-admin'

const SchoolClassListFilters = [
    <SearchInput variant="outlined" placeholder="Search class" source="name" alwaysOn />,
    <BooleanInput source="active" label="Published" variant="outlined" defaultValue={true} />
]

export default SchoolClassListFilters
